import React, { useEffect, useState } from "react";
import {
  deleteUser,
  resetOAuth,
  updatedUserStatus,
} from "../../services/userService";
import { ToastContainer, toast } from "react-toastify";
import { deleteTransriptByID } from "../../services/transcriptService";
import { deletePromptByID } from "../../services/promptService";
import { RotatingLines } from "react-loader-spinner";

const ConfirmModal = ({
  setUploads,
  setPrompts,
  setIsOpen,
  functionData,
  setLoading,
  setFunctionData,
  setAllUsers,
}) => {
  const [confirm, setConfirm] = useState(false);

  const deleteUserById = async (request) => {
    setLoading(true);
    try {
      const res = await deleteUser(request);
      setFunctionData(null);
      setConfirm(false);
      if (res?.status === "success") {
        setIsOpen(false);
        setAllUsers((prevUsers) => {
          return prevUsers.map((user) => {
            if (user.id === request.id) {
              return {
                ...user,
                isActive: false,
              };
            } else {
              return user;
            }
          });
        });
        setLoading(false);
        toast(res.message);
      } else throw new Error("Failed To Update User Status");
    } catch (e) {
      setIsOpen(false);
      setLoading(false);
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  const updateStatus = async (request) => {
    console.log(request);

    setLoading(true);
    try {
      const res = await updatedUserStatus(request);
      setFunctionData(null);
      setConfirm(false);
      if (res?.status === "success") {
        setIsOpen(false);
        setLoading(false);
        setAllUsers((prevUser) => {
          return prevUser.map((user) => {
            if (user.email === request.email) {
              console.log(user);
              return {
                ...user,
                isActive: request.status,
              };
            } else {
              return user;
            }
          });
        });
        toast("Updated User status sucessfully");
      } else throw new Error("Failed To Update User Status");
    } catch (e) {
      setIsOpen(false);
      setLoading(false);
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  const deleteTranscript = async (request) => {
    setLoading(true);
    try {
      const res = await deleteTransriptByID(request.id);
      setFunctionData(null);
      setConfirm(false);
      if (res?.status === "success") {
        setIsOpen(false);
        setLoading(false);
        setUploads((prevState) => {
          return prevState.filter((item) => item.id !== request.id);
        });
        toast(res.message);
      } else throw new Error("Fetching Failed");
    } catch (e) {
      setIsOpen(false);
      setLoading(false);
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  const deletePrompt = async (request) => {
    console.log(request);
    setLoading(true);
    try {
      const res = await deletePromptByID(request);
      setFunctionData(null);
      setConfirm(false);
      if (res?.status === "success") {
        setIsOpen(false);
        setPrompts((prevPrompts) => {
          return prevPrompts.filter((item) => item.id !== request);
        });
        setLoading(false);
        toast(res.message);
      } else throw new Error("Fetching Failed");
    } catch (e) {
      setIsOpen(false);
      setLoading(false);
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  const reset2factorAuth = async (id) => {
    try {
      const data = await resetOAuth(id);

      setFunctionData(null);
      setConfirm(false);

      if (data.status === "success") {
        setIsOpen(false);
        toast("OAuth Reset Successfully");
      } else {
        toast("Something went wrong");
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      setIsOpen(false);
      setLoading(false);
      console.error(error);
      toast("Failed to reset OAuth");
    }
  };

  useEffect(() => {
    if (confirm === false) return;

    if (functionData.type === "ACTIVATE") updateStatus(functionData.data);

    if (functionData.type === "DELETE") deleteUserById(functionData.data);

    if (functionData.type === "RESET") reset2factorAuth(functionData.data.id);

    if (functionData.type === "DELETE-TRANSCRIPT")
      deleteTranscript(functionData.data);

    if (functionData.type === "DELETE-PROMPT") deletePrompt(functionData.data);

    // eslint-disable-next-line
  }, [confirm]);

  return (
    <>
      <ToastContainer />
      <div className="darkBG" onClick={() => setIsOpen(false)} />
      <div className="centered">
        {confirm ? (
          <div className="modal">
            <div id="svg-container">
              <RotatingLines
                visible={true}
                height="96"
                width="96"
                color="red"
                strokeColor="grey"
                strokeWidth="4"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          </div>
        ) : (
          <div className="modal">
            <div
              className="loginCardWrapper"
              style={{ padding: "10px", display: "flex", flexDirection: "row" }}
            >
              <div
                style={{ flex: 1, display: "flex", justifyContent: "center" }}
              >
                <div
                  style={{
                    height: "70px",
                    width: "70px",
                    borderRadius: "50%",
                    border: "1px solid grey",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ion-icon
                    name="warning-outline"
                    style={{ color: "black", fontSize: 28 }}
                  ></ion-icon>
                </div>
              </div>
              <div style={{ flex: 4, padding: "10px" }}>
                <h3 style={{ color: "black" }}>Warning !</h3>
                <span
                  style={{
                    marginTop: 0,
                    color: "grey",
                    fontWeight: 500,
                    fontSize: "0.8rem",
                  }}
                >
                  {functionData?.type === "DELETE-TRANSCRIPT" ||
                  functionData?.type === "DELETE-PROMPT"
                    ? "You will lose all of your data by deleting this. This action cannot be undone"
                    : functionData?.type === "DELETE"
                    ? "Be certain before you proceed. After deleting the account,it will first be deactivated for 30 days and after that the account will be permanently deleted and cannot be undone. You will lose all access to account data"
                    : functionData?.type === "RESET"
                    ? "Are you sure you want to Reset 2 Factor Auth?"
                    : "Are you sure you want to update status ?"}
                </span>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                    gap: 10,
                  }}
                >
                  <button
                    className="deleteBtn"
                    style={{ border: "none", cursor: "pointer" }}
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    className="confirmBtn"
                    style={{ border: "none", cursor: "pointer" }}
                    onClick={() => {
                      setConfirm(true);
                    }}
                  >
                    {functionData?.type === "DELETE" ||
                    functionData?.type === "DELETE-TRANSCRIPT" ||
                    functionData?.type === "DELETE-PROMPT"
                      ? "Delete"
                      : functionData?.data?.status === false
                      ? "Deactivate"
                      : functionData?.type === "RESET"
                      ? "Reset"
                      : "Activate"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ConfirmModal;
